<template>
    <div class="input-component" :class="{ 'not-icon': !wantIcon }" ref="container">
        <div class="label" v-if="label">
            {{label === '_' ? '\u00A0' : label}}
        </div>
        <div class="skeleton" :class="{'match': valuesMatch, 'no-match': valuesDontMatch, 'action': hasSlot('action')}">
            <div class="saturn" :class="{'invalid': invalid}" @click="toggleShowError(null, $event)" @mouseover="toggleShowError(true, $event)" @mouseleave="toggleShowError(false, $event)">
                <div class="saturn-textbox" :class="cssClass">

                    <input v-if="!multiline"
                           :type="'type' in $props ? type : 'text'"
                           v-model="vm.saturn"
                           :placeholder="placeholder"
                           :readonly="readonly"
                           :disabled="disabled"
                           v-on:blur="onBlurHandler"
                           :maxlength="maxlength"
                           :minlength="minlength"
                           v-on:input="onInputHandler"
                           v-on:focus="onFocusInput"
                           :pattern="pattern" 
                           ref="inputHandle"
                           @keyup.enter="enterHandler"/>
                    <textarea v-else
                              v-model="vm.saturn"
                              :placeholder="placeholder"
                              :readonly="readonly"
                              :disabled="disabled"
                              :class="cssClass"
                              v-on:blur="onBlurHandler"
                              :maxlength="maxlength"
                              :minlength="minlength"
                              :cols="cols"
                              :rows="rows"/>

                    <div class="saturn-textbox-error-message" v-if="errorHover && invalid">
                        <div v-if="hasSlot('validation')">
                            <slot name="validation"></slot>
                        </div>
                        <div v-else>
                            Invalid Input
                        </div>
                    </div>

                </div>

                <div v-if="hasSlot('action')" class="action-slot">
                    <slot name="action"></slot>
                </div>
                <div v-else-if="!hasSlot('action') && wantIcon" class="saturn-icon">
                    <i :class="iconStyle"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import util from '@/helpers/util';

    export default {
        name: "InputTextbox",
        props: ['saturn', 'cdk', 'label', 'placeholder', 'invalid', 'readonly', 'disabled', 'multiline', 'cssClass', 'copy', 'comparer', 'get', 'set', 'maxlength', 'minlength', 'type', 'pattern', 'showIcon', 'icon', 'isUpperCase', 'nameValidation', 'cols', 'rows'],
        data() {
            return {
                vm: {
                    saturn: null,
                    cdk: null
                },
                errorHover: false,
                wantIcon: null,
                iconStyle: null,
                previousValue: null
            };
        },
        computed: {
            valuesMatch() {
                if (this.comparer)
                    return this.hasProp('cdk') && this.comparer(this.vm.saturn, this.vm.cdk);
                else
                    return this.hasProp('cdk') && this.isNull(this.vm.saturn) === this.isNull(this.vm.cdk);
            },
            valuesDontMatch() {
                if (this.comparer)
                    return this.hasProp('cdk') && !this.comparer(this.vm.saturn, this.vm.cdk);
                else
                    return this.hasProp('cdk') && this.isNull(this.vm.saturn) !== this.isNull(this.vm.cdk);
            },
            hasValidationSlot() {
                return !!this.$slots['validation']
            }
        },
        created() {
            this.init();
            this.wantIcon = typeof this.showIcon != 'undefined' ? this.showIcon : true;
            this.iconStyle = !util.isNull(this.multiline) ? 'fas fa-paragraph' : !util.isNull(this.icon) ? this.icon : 'fas fa-font'

            this.$watch(() => this.$props, function (newValue) {
                this.init();
            }, { deep: true, immediate: true });

            if (!this.get) {
                this.$watch(() => this.vm.saturn, function (newValue) {
                    this.vm.saturn = this.isUpperCase && newValue ? newValue.toUpperCase() : newValue
                    this.$emit('update:saturn', this.vm.saturn);
                    this.$emit('change');
                }, { deep: true });
            }
        },
        methods: {
            enterHandler() {
                this.$emit('keyEnter');
            },
            onInputHandler(e) {
                this.$emit('input', e)
            },
            handleInput(e) {
                console.log(e.target.value)
                if (this.nameValidation) {
                    if (this.vm.saturn.match(/^[a-zA-Z\s-]+$/g) || this.vm.saturn == "") {
                        this.previousValue = this.vm.saturn
                        this.$emit('update:saturn', this.vm.saturn);
                        this.$emit("input", e.target.value)
                    } else {
                        this.$emit('update:saturn', this.previousValue);
                        this.vm.saturn = this.previousValue
                    }
                }
            },
            isNull(val) {
                if (val === null) {
                    return '';
                }
                else {
                    return val;
                }
            },
            copyValueFromCDK() {
                if (this.copy) {
                    this.vm.saturn = this.copy(this.vm.cdk);
                }
                else {
                    this.vm.saturn = this.vm.cdk;
                }

                this.updateSaturnGetterVersion();
            },
            init() {
                this.vm.saturn = this.set ? this.set(this.saturn) : this.saturn;
                this.previousValue = this.vm.saturn
                this.vm.cdk = this.cdk;
            },
            toggleShowError(override, event) {
                let isMobile = window.matchMedia('(max-width: 600px)').matches;

                if (event.type === 'click') {
                    this.errorHover = !this.errorHover
                }
                else if (!isMobile) {
                    this.errorHover = override;
                }
            },
            hasSlot(name) {
                return !!this.$slots[name]
            },
            hasProp(name) {
                return name in this.$options.propsData;
            },
            onBlurHandler($e) {
                this.updateSaturnGetterVersion();
                this.$emit('blur', $e);
            },
            onFocusInput() {
                this.$emit('focus');
            },
            updateSaturnGetterVersion() {
                if (this.get) {
                    this.$emit('update:saturn', this.get(this.isUpperCase ? this.vm.saturn.toUpperCase : this.vm.saturn));
                    this.$emit('change');
                }
            }
        },
        components: {

        }
    };

    /*
     * USAGE
     *

     <InputTextbox label="Customer" :saturn.sync="customer1.saturn" :cdk="customer1.cdk" :invalid="$v.customer1.saturn.$invalid" placeholder="Name">
        <template #validation>
            <div v-if="!$v.customer1.saturn.required">Customer is required</div>
        </template>
    </InputTextbox>

     <InputTextbox label="Customer" :saturn.sync="customer1.saturn" placeholder="Name" :invalid="$v.customer1.saturn.$invalid" readonly="true"></InputTextbox>
     <InputTextbox label="Customer" :saturn.sync="customer1.saturn" placeholder="Name" :invalid="$v.customer1.saturn.$invalid"></InputTextbox>
    */

</script>



